
















































import { Component, Model, Watch, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import PermissionApi from '@/api/permission/index'

@Component({
  components: {}
})
export default class Permission extends AbpBase {
  @Model('change', { type: Boolean }) modal!: boolean

  @Prop({ type: String, default: '' }) providerName!: string
  @Prop({ type: String, default: '' }) providerKey!: string
  permissionData = { entityDisplayName: '', groups: [] }
  permissions = []
  mounted() {}
  onCancel() {
    this.$emit('change', false)
  }
  @Watch('modal', { immediate: true })
  modalChange(val) {
    if (val) {
      PermissionApi.getPermissions(this.providerName, this.providerKey).then(
        res => {
          this.permissionData = res.data
          this.getPermissions(this.permissionData.groups[0])
        }
      )
    }
  }
  getPermissions(item) {
    this.permissions = item.permissions.reduce(
      (total, currentValue, index, arr) => {
        if (currentValue.parentName === null) {
          var childers = arr.filter(t => t.parentName === currentValue.name)
          currentValue.items = childers
          total.push(currentValue)
        }
        console.log(total)
        return total
      },
      []
    )
  }
  save() {
    var permissions = []
      .concat(...this.permissionData.groups.map(x => x.permissions))
      .map(x => {
        return {
          name: x.name,
          isGranted: x.isGranted
        }
      })
    PermissionApi.putPermissions(this.providerName, this.providerKey, permissions).then(res => {
      this.$Message.success('保存成功')
      this.$emit('change', false)
    })
  }
}
